import { useEffect } from "react";

const SITE = "Glam Girl Makeup Studio";

export default function SEO({ title, description }) {
  useEffect(() => {
    const full = title ? `${title} — ${SITE}` : `${SITE} — Ladies Salon & Bridal Makeup in Varanasi`;
    document.title = full;
    const set = (attr, key, content) => {
      const el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (el && content) el.setAttribute("content", content);
    };
    set("name", "description", description);
    set("property", "og:title", full);
    set("property", "og:description", description);
  }, [title, description]);
  return null;
}
